import { Box } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { PaginationLoadingOverlay } from "../../../clients/PaginationLoadingOverlay";
import { useAuthContextualToken } from "../../hooks/useAuthContextualToken";
import { useQuotes } from "../../hooks/useQuotes";
import { QuoteSummary } from "../summary/QuoteSummary";

export const QuoteView = ({ quoteId }) => {
  const { id: idFromParams } = useParams();
  const finalId = quoteId ?? idFromParams;

  const { token, role } = useAuthContextualToken();

  const { getQuoteById, selectedQuote, loading } = useQuotes();

  useEffect(() => {
    if (finalId && token) {
      getQuoteById(finalId, token, true);
    }
  }, [finalId, token]);

  return (
    <Box>
      <PaginationLoadingOverlay isVisible={loading} />

      {!loading && selectedQuote && <QuoteSummary quote={selectedQuote} role={role} />}

      {!loading && !selectedQuote && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            minHeight: 220,
            color: "var(--fx-surface-texttertiary, #94A3B8)",
            fontSize: "0.875rem",
            fontWeight: 600,
            borderRadius: 4,
            border: "1px solid var(--fx-surface-border, #E2E8F0)",
            boxShadow: "0px 4px 20px rgba(0,0,0,0.03)",
          }}
        >
          Quote not found or invalid ID.
        </Box>
      )}
    </Box>
  );
};
